module.exports = __webpack_public_path__ + "img/150.9b7f4654.jpg";